interface IPresentation {
  id: string;
  title: string;
  subtitle: string;
  /**
   * url to the title image
   */
  titleImage: string | null;
  /**
   * url to the document
   */
  documentHtml: string;
  /**
   * Threshold for detecting inactivity (in [s]).
   * If 0, detection should be deactivated
   */
  inactiveTreshold: number;
}

export class Presentation implements IPresentation {
  public id: string;
  public title: string;
  public subtitle: string;
  public titleImage: string | null;
  public documentHtml: string;
  public inactiveTreshold: number;

  constructor(dto: Readonly<IPresentation>) {
    this.id = dto.id;
    this.title = dto.title;
    this.subtitle = dto.subtitle;
    this.titleImage = dto.titleImage;
    this.documentHtml = dto.documentHtml;
    this.inactiveTreshold = dto.inactiveTreshold;
  }
}
